export default "__VITE_ASSET__DRqjQR4U__"